module.exports = __webpack_public_path__ + "static/media/pplogo-64.eed28164.ico";